import { toast } from "@/components/ui/use-toast";
import axios from "axios";


// get notifications data in the form of 
// data
// : 
// entityId
// : 
// "a5b375f0-0b99-41e9-909c-0ecde000c85e"
// notificationId
// : 
// "e3ea8088-f26a-4a90-bda6-9e8681428459"
// payload
// : 
// routingType
// : 
// "manual"
// title
// : 
// "hey"
// then get the data from the response and return it
// then call a toast notification with the data

export const showNotification = (data: any) => {
    console.log(data);
    toast({
        title: "New Unassigned Ticket",
        description: data.payload.title,
        variant: "default",
    });
}

const notificationData = {
    data: {
        entityId: "a5b375f0-0b99-41e9-909c-0ecde000c85e",
        notificationId: "e3ea8088-f26a-4a90-bda6-9e8681428459",
        payload:{
            routingType: "manual",
            title: "hey"
        },
    }
}


const getNotifications = async () => {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/notifications`);
    return response.data;
};

